module.exports = __webpack_public_path__ + "static/media/Avenir-Black.1f187572.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Avenir-Black.woff
// module id = 72
// module chunks = 0